import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Footer } from "../components/NewLandingPage/Footer";
import { Header } from "../components/NewLandingPage/Header";
import { HeroSection } from "../components/NewLandingPage/HeroSection";
import { HowItWorks } from "../components/NewLandingPage/HowItWorks";
import { TipsSection } from "../components/NewLandingPage/TipsSection";
import { FeedbackModal } from "../components/Authentication/FeedbackModal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useMemo } from "react";
import Cookies from "js-cookie";
import { setRefresh } from "../store/slices/UserSlice";
import { setShowFeedBack } from "../store/slices/MainScreenSlice";
import { useLandingAuth } from "../hooks/use-landing-auth"; 

export const NewLadingPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const showModal = useSelector(
    (state: RootState) => state.mainScreen.showFeedBack,
  );
  const refresh = useSelector((state: RootState) => state.user.refresh);
  const { languageParam } = useParams();
  const SUPPORTED_LANGS = useMemo(() => ["ar", "en"], []);
  const navigate = useNavigate();
  const landingAuth = useLandingAuth();

  useEffect(() => {
    if (languageParam && !SUPPORTED_LANGS.includes(languageParam)) {
      // Redirect to default language, e.g., French
      navigate("/", { replace: true });
      return;
    }
    let language = languageParam || Cookies.get("language");
    if (!language) language = "ar";
    i18n.changeLanguage(language);
  }, [SUPPORTED_LANGS, i18n, languageParam, navigate]);

  useEffect(() => {
    if (refresh) {
      dispatch(setRefresh({}));
      window.location.reload();
    }
  }, [refresh, dispatch]);

  return (
    <>
      <Helmet>
        <title>{t("helmet.home_title")}</title>
        <meta
          name="description"
          content={
            t("helmet.home_desc") || "Propaganda is an online funny board game"
          }
        />
      </Helmet>
      <div className="bg-hero-orange">
        <Header />
        <HeroSection landingAuth={landingAuth} />
        <TipsSection />
        <HowItWorks landingAuth={landingAuth} />
        <Footer />

        {showModal && (
          <FeedbackModal
            setShowModal={() => dispatch(setShowFeedBack(false))}
          />
        )}
      </div>
    </>
  );
};
